import { EventCard } from '@/sanity/fetchEvents';
import { getFirstValidEventDate } from './EventFacts';
import { generateGoogleMapsLink } from '@/utils/api-helpers';
import Chip from '../base/Chip';
import styles from './EventDateAndLocation.module.scss';

const EventDateAndLocation = ({
  event,
  currentDate = new Date(),
  className,
}: {
  event: EventCard;
  currentDate?: Date;
  className?: string;
}) => {
  const firstValidEventDate = getFirstValidEventDate(event, currentDate); // Assume this function is defined elsewhere
  const googleMapsLinks = generateGoogleMapsLink(event.location);

  return (
    <div className={className}>
      <div className={styles.chipList}>
        {firstValidEventDate && (
          <Chip label={firstValidEventDate} icon="/icons/icon-calendar.svg" />
        )}

        {event?.location?.name && (
          <Chip
            label={event.location?.name}
            icon="/icons/icon-map.svg"
            href={googleMapsLinks}
          />
        )}
      </div>
    </div>
  );
};

export default EventDateAndLocation;
